/**
 * Lab diagnostics module-details request/response shapes.
 * Mirrors backend/src/modules/lab/lab.validators.ts.
 */

export type LabServiceRadius = 'KM_5' | 'KM_10' | 'KM_20' | 'KM_30' | 'KM_50';

export type LabSampleType = 'BLOOD' | 'URINE' | 'STOOL' | 'SWAB' | 'OTHER';

export type LabDetailsRequest = {
  registration_number?: string;
  home_collection_available: boolean;
  service_radius?: LabServiceRadius;
  sample_types: LabSampleType[]; // 1..8 unique
};

export type LabDetailsResponse = {
  id: string;
  vendor_profile_id: string;
  registration_number: string | null;
  home_collection_available: boolean;
  service_radius: LabServiceRadius | null;
  sample_types: LabSampleType[];
  created_at: string;
  updated_at: string;
};

export const LAB_SERVICE_RADIUS_OPTIONS: Array<{ value: LabServiceRadius; label: string }> = [
  { value: 'KM_5', label: '5 km' },
  { value: 'KM_10', label: '10 km' },
  { value: 'KM_20', label: '20 km' },
  { value: 'KM_30', label: '30 km' },
  { value: 'KM_50', label: '50 km' },
];

export const LAB_SAMPLE_TYPE_OPTIONS: Array<{ value: LabSampleType; label: string }> = [
  { value: 'BLOOD', label: 'Blood' },
  { value: 'URINE', label: 'Urine' },
  { value: 'STOOL', label: 'Stool' },
  { value: 'SWAB', label: 'Swab' },
  { value: 'OTHER', label: 'Other' },
];
